import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BiometricType, MobileWebViewService } from '@mpt-fo/common/core/services/mobile-web-view.service';
import { DelegateType } from '@mpt-fo/common/shared/models/utility.model';
import { MobileDelegateService } from '@mpt-fo/common/core/services/mobile-delegate.service';
import {AppConfig} from '@mpt-fo/common/shared/config/app-config';

@Component({
	selector: 'app-splash-screen',
	templateUrl: './splash-screen.component.html',
	styleUrls: ['./splash-screen.component.scss'],
})
export class SplashScreenComponent implements OnInit {
	carouselItems = [
		{
			title: 'Grow your Businesses',
			titleII: '',
			imgLink: '../../../../assets/images/svgs/splash1.svg',
			description: 'Easily access all the tools you need to grow,' + ' manage and protect your business on the go.',
		},
		{
			title: 'Access Business Loans',
			titleII: '',
			imgLink: '../../../../assets/images/svgs/splash2.svg',
			description: 'Get quick and low-interest loans.' + ' Apply today and get the funds you need to keep your business running.',
		},
		{
			title: 'Accept Instant Payments',
			titleII: '',
			imgLink: '../../../../assets/images/svgs/splash3.svg',
			description:
				'We provide your business with multiple' +
				' payment options to accept payment via POS, ' +
				'bank transfers or web payment gateways.',
		},
		{
			title: 'Get a business',
			titleII: 'account in 5 mins',
			imgLink: '../../../../assets/images/svgs/splash4.svg',
			description:
				'Open a bank account in your business name ' +
				'and start accepting payment,' +
				' accessing loans and a range of business solutions.',
		},
	];

	constructor(
		private router: Router,
		private mobileService: MobileWebViewService,
		private delegateService: MobileDelegateService,
		private config: AppConfig) {}

	ngOnInit(): void {
		this.initialize();
	}

	initialize() {
		this.delegateService
			.getDelegateData(DelegateType.getBiometricType)
			.then((res) => {
				let biometricType = BiometricType[res.toString()];
				biometricType = biometricType || BiometricType.NONE;
				this.mobileService.setBiometricType(biometricType);
			})
			.catch((error) => {
				console.log('Error getting BiometricType ', error);
			});
	}

	route(route) {
		this.router.navigate([`/login`], { queryParams: { isUserFromSlashScreen: true } });
	}

	signUp(){
		let route = '/onboarding/create-account';
		const canUseNewOnboardingFlow = this.config.USE_NEW_SIGN_UP_FLOW;
		if (canUseNewOnboardingFlow) {
			route = `/onboarding-v2`;
		}
		this.router.navigateByUrl(route);
	}
}
